module.exports = __webpack_public_path__ + "media/member-left.520d23f9.ogg";